import { useQuery, UseQueryResult } from '@tanstack/react-query'

export function useHLName(account?: string): UseQueryResult<string, Error> {
  const data = useQuery({
    queryKey: ['getUserHLName', account],
    queryFn: async () => {
      const response = await fetch(`https://api.hlnames.xyz/resolve/primary_name/${account}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.NEXT_PUBLIC_HL_NAME_API_KEY ?? '',
        },
      })

      if (!response.ok) {
        console.error('Failed to fetch HLName', response)
        return ''
      }

      const result = (await response.json()) as unknown as { primaryName: string }
      return result.primaryName
    },
    enabled: Boolean(account),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    refetchInterval: false,
    refetchOnReconnect: false,
  })

  return data
}
